module.exports = __webpack_public_path__ + "img/08.8ac69ece.png";